// The independently-served AP frontend (packages/web) origin, read once at
// module load. Shared by every iframe embed that needs to address it
// directly (the real builder in ApBuilderIframe.jsx, the read-only preview
// in TemplateFlowPreview.jsx) so the fallback host and trailing-slash strip
// can't drift between them.
export const apFrontendUrl = (
  window.env?.REACT_APP_AP_FRONTEND_URL || "http://localhost:4200"
).replace(/\/$/, "");
